import Skeleton from '@/components/dataDisplay/Skeleton';

const HeaderNavigationPlaceholder = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        padding: 10,
        justifyContent: 'space-between',
      }}
    >
      <Skeleton style={{ height: '42px', width: '42px', borderRadius: '1000px' }} />
      <Skeleton style={{ height: '42px', width: '60%' }} />
      <Skeleton style={{ height: '42px', width: '42px', borderRadius: '1000px' }} />
    </div>
  );
};

export default HeaderNavigationPlaceholder;
